<template>
<div class="grid"  v-show="data.show">
<div class="col-12 md:col-2"><h5 class="mt-1 mb-0">{{data.title}}</h5></div>
<div class="col-12 md:col-10 "><InputSwitch v-model="inputdata" @change="emitValue"  /></div>
</div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {

  name: 'InputSwitchValidate',
  props:["data","fieldindex"],
  data () {
    return {
    	inputdata:null,
    }
  },
  computed:{
  	dataValue()
  	{
      
  		return this.data.value
  	}
  },
  watch:{
  	dataValue(newVal,oldVal)
  	{
  		this.inputdata = this.dataValue
  	}
  },
  methods:{
  	emitValue()
  	{
  		this.$emit("emitValue",{value:this.inputdata,index:this.fieldindex})
  	},
  }
};
</script>

<style lang="css" scoped>
</style>